module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/object/assign.js
// module id = 243
// module chunks = 0